export default function getRedriveTargetStep(machine_input: any): string | null {
    const parentJobName = machine_input?.openlineage?.parentJobName
    if (typeof parentJobName !== 'string' || !parentJobName.includes('.')) return null
    return parentJobName.slice(parentJobName.indexOf('.') + 1)
}
